export default "__VITE_ASSET__BNlY3bAA__"